<template>
  <transition name="fade" appear>
    <div class="columns is-multiline extrapadding">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: { skipGroupTransition: Boolean },
};
</script>
